import { render, staticRenderFns } from "./WorkerFormDocument.vue?vue&type=template&id=5b2f6914"
import script from "./WorkerFormDocument.vue?vue&type=script&lang=ts"
export * from "./WorkerFormDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports